import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'

import { trpc } from 'src/utils/trpc'

import { SpeciesTile } from './SpeciesTile'

export const SpeciesSection = () => {
  const {
    data: allSpecies,
    isLoading,
    isError
  } = trpc.useQuery(['sanity.getAllNativeTreeSpecies'])

  if (isLoading) {
    return <LoadingSpinner isLoading />
  }

  if (isError || (!isLoading && !allSpecies) || allSpecies.length === 0) {
    // TODO: add an error boundary/something went wrong at a component level
    return null
  }

  return (
    <div className='flex flex-wrap gap-10'>
      {allSpecies?.map(species => (
        <SpeciesTile key={species._id} {...species} />
      ))}
    </div>
  )
}
